import { $themeConfig } from "@themeConfig"

export default {
  namespaced: true,
  state: {
    isVerticalMenuCollapsed: $themeConfig.layout.menu.isCollapsed,
    currentPathNavbar: "",
    currentModuleNavbar: "",
    enabledNavbar: {},
    firstCustomerWpmPermission: "",
    webPortalModuleEnabledSidebar: {},
    serverManagementModuleEnabledSidebar: {},
    backupManagementModuleEnabledSidebar: {},
    networkConfigurationModuleEnabledSidebar: {},
    internalEnabledNavbar: {},
    firstInternalWPMPermission: "",
    firstInternalSMSPermission: "",
    firstInternalBMMPermission: "",
    firstInternalNCMPermission: "",
    internalWebPortalModuleEnabledSidebar: {},
    internalServerManagementModuleEnabledSidebar: {},
    internalBackupManagementModuleEnabledSidebar: {},
    internalNetworkConfigurationModuleEnabledSidebar: {},
  },
  getters: {
    getCurrentPathNavbar(state) {
      return state.currentPathNavbar
    },
    getCurrentModuleNavbar(state) {
      return state.currentModuleNavbar
    },

    // * getters for external user
    getEnabledNavbar(state) {
      return state.enabledNavbar
    },
    getWebPortalModuleEnabledSidebar(state) {
      return state.webPortalModuleEnabledSidebar
    },
    getServerManagementModuleEnabledSidebar(state) {
      return state.serverManagementModuleEnabledSidebar
    },
    getBackupManagementModuleEnabledSidebar(state) {
      return state.backupManagementModuleEnabledSidebar
    },
    getNetworkConfigurationModuleEnabledSidebar(state) {
      return state.networkConfigurationModuleEnabledSidebar
    },
    getCustomerFirstWpmPermission(state) {
      return state.firstCustomerWpmPermission
    },

    // * getters for internal user
    getInternalEnabledNavbar(state) {
      return state.internalEnabledNavbar
    },
    getInternalWebPortalModuleEnabledSidebar(state) {
      return state.internalWebPortalModuleEnabledSidebar
    },
    getInternalServerManagementModuleEnabledSidebar(state) {
      return state.internalServerManagementModuleEnabledSidebar
    },
    getInternalBackupManagementModuleEnabledSidebar(state) {
      return state.internalBackupManagementModuleEnabledSidebar
    },
    getInternalNetworkConfigurationModuleEnabledSidebar(state) {
      return state.internalNetworkConfigurationModuleEnabledSidebar
    },
    getInternalFirstWpmPermission(state) {
      return state.firstInternalWpmPermission
    },
    getInternalFirstSmsPermission(state) {
      return state.firstInternalSmsPermission
    },
    getInternalFirstBmmPermission(state) {
      return state.firstInternalBmmPermission
    },
    getInternalFirstNcmPermission(state) {
      return state.firstInternalNcmPermission
    },
  },
  mutations: {
    UPDATE_VERTICAL_MENU_COLLAPSED(state, val) {
      state.isVerticalMenuCollapsed = val
    },
    UPDATE_CURRENT_PATH_NAVBAR(state, path) {
      state.currentPathNavbar = path
    },
    UPDATE_CURRENT_MODULE_NAVBAR(state, module) {
      state.currentModuleNavbar = module
    },

    // * External Navbar Sidebar
    UPDATE_ENABLED_NAVBAR(state, menu) {
      Object.assign(state.enabledNavbar, menu)
    },
    UPDATE_WEB_PORTAL_MODULE_ENABLED_SIDEBAR(state, menu) {
      Object.assign(state.webPortalModuleEnabledSidebar, menu)
    },
    UPDATE_SERVER_MANAGEMENT_MODULE_ENABLED_SIDEBAR(state, menu) {
      Object.assign(state.serverManagementModuleEnabledSidebar, menu)
    },
    UPDATE_BACKUP_MANAGEMENT_MODULE_ENABLED_SIDEBAR(state, menu) {
      Object.assign(state.backupManagementModuleEnabledSidebar, menu)
    },
    UPDATE_NETWORK_CONFIGURATION_MODULE_ENABLED_SIDEBAR(state, menu) {
      Object.assign(state.networkConfigurationModuleEnabledSidebar, menu)
    },
    SET_FIRST_CUSTOMER_WPM_PERMISSION(state, permissionName) {
      state.firstCustomerWpmPermission = permissionName
    },

    // * Internal Navbar Sidebar
    UPDATE_INTERNAL_ENABLED_NAVBAR(state, menu) {
      Object.assign(state.internalEnabledNavbar, menu)
    },
    UPDATE_INTERNAL_WEB_PORTAL_MODULE_ENABLED_SIDEBAR(state, menu) {
      Object.assign(state.internalWebPortalModuleEnabledSidebar, menu)
    },
    UPDATE_INTERNAL_SERVER_MANAGEMENT_MODULE_ENABLED_SIDEBAR(state, menu) {
      Object.assign(state.internalServerManagementModuleEnabledSidebar, menu)
    },
    UPDATE_INTERNAL_BACKUP_MANAGEMENT_MODULE_ENABLED_SIDEBAR(state, menu) {
      Object.assign(state.internalBackupManagementModuleEnabledSidebar, menu)
    },
    UPDATE_INTERNAL_NETWORK_CONFIGURATION_MODULE_ENABLED_SIDEBAR(state, menu) {
      Object.assign(
        state.internalNetworkConfigurationModuleEnabledSidebar,
        menu
      )
    },
    SET_FIRST_INTERNAL_WPM_PERMISSION(state, permissionName) {
      state.firstInternalWpmPermission = permissionName
    },
    SET_FIRST_INTERNAL_SMS_PERMISSION(state, permissionName) {
      state.firstInternalSmsPermission = permissionName
    },
    SET_FIRST_INTERNAL_BMM_PERMISSION(state, permissionName) {
      state.firstInternalBmmPermission = permissionName
    },
    SET_FIRST_INTERNAL_NCM_PERMISSION(state, permissionName) {
      state.firstInternalNcmPermission = permissionName
    },
  },
  actions: {
    setVerticalMenuCollapse({ commit }, value) {
      commit("UPDATE_VERTICAL_MENU_COLLAPSED", value)
    },
    setCurrentPathNavbar({ commit }, path) {
      commit("UPDATE_CURRENT_PATH_NAVBAR", path)
    },
    setCurrentModuleNavbar({ commit }, module) {
      commit("UPDATE_CURRENT_MODULE_NAVBAR", module)
    },

    // * Action for external user
    setEnabledNavbar({ commit }, menu) {
      commit("UPDATE_ENABLED_NAVBAR", menu)
    },
    setWebPortalModuleEnabledSidebar({ commit }, menu) {
      commit("UPDATE_WEB_PORTAL_MODULE_ENABLED_SIDEBAR", menu)
    },
    setServerManagementModuleEnabledSidebar({ commit }, menu) {
      commit("UPDATE_SERVER_MANAGEMENT_MODULE_ENABLED_SIDEBAR", menu)
    },
    setBackupManagementModuleEnabledSidebar({ commit }, menu) {
      commit("UPDATE_BACKUP_MANAGEMENT_MODULE_ENABLED_SIDEBAR", menu)
    },
    setNetworkConfigurationModuleEnabledSidebar({ commit }, menu) {
      commit("UPDATE_NETWORK_CONFIGURATION_MODULE_ENABLED_SIDEBAR", menu)
    },
    setFirstCustomerWpmPermission({ commit }, permissionName) {
      commit("SET_FIRST_CUSTOMER_WPM_PERMISSION", permissionName)
    },

    // * Action for internal user
    setInternalEnabledNavbar({ commit }, menu) {
      commit("UPDATE_INTERNAL_ENABLED_NAVBAR", menu)
    },
    setInternalWebPortalModuleEnabledSidebar({ commit }, menu) {
      commit("UPDATE_INTERNAL_WEB_PORTAL_MODULE_ENABLED_SIDEBAR", menu)
    },
    setInternalServerManagementModuleEnabledSidebar({ commit }, menu) {
      commit("UPDATE_INTERNAL_SERVER_MANAGEMENT_MODULE_ENABLED_SIDEBAR", menu)
    },
    setInternalBackupManagementModuleEnabledSidebar({ commit }, menu) {
      commit("UPDATE_INTERNAL_BACKUP_MANAGEMENT_MODULE_ENABLED_SIDEBAR", menu)
    },
    setInternalNetworkConfigurationModuleEnabledSidebar({ commit }, menu) {
      commit(
        "UPDATE_INTERNAL_NETWORK_CONFIGURATION_MODULE_ENABLED_SIDEBAR",
        menu
      )
    },
    setFirstInternalWpmPermission({ commit }, permissionName) {
      commit("SET_FIRST_INTERNAL_WPM_PERMISSION", permissionName)
    },
    setFirstInternalSmsPermission({ commit }, permissionName) {
      commit("SET_FIRST_INTERNAL_SMS_PERMISSION", permissionName)
    },
    setFirstInternalBmmPermission({ commit }, permissionName) {
      commit("SET_FIRST_INTERNAL_BMM_PERMISSION", permissionName)
    },
    setFirstInternalNcmPermission({ commit }, permissionName) {
      commit("SET_FIRST_INTERNAL_NCM_PERMISSION", permissionName)
    },
  },
}
